(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("React.addons.CSSTransitionGroup"), require("React.addons.TransitionGroup"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "React.addons.CSSTransitionGroup", "React.addons.TransitionGroup"], factory);
	else if(typeof exports === 'object')
		exports["ReactMD"] = factory(require("react"), require("react-dom"), require("React.addons.CSSTransitionGroup"), require("React.addons.TransitionGroup"));
	else
		root["ReactMD"] = factory(root["React"], root["ReactDOM"], root["React.addons.CSSTransitionGroup"], root["React.addons.TransitionGroup"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_138__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition